module.exports = __webpack_public_path__ + "img/49-mensagens-comunicado.923d9e60.png";